import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import api from "../services/api.service";
import * as Styles from "../styles/Customer.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
import { infosDoTipo } from "../dominio/conta.tipos";
import {
  baseDoDesconto,
  descontoDaConta,
  taxaPorTipo,
  taxasDaConta,
  totalDeTaxas,
  totalDosProdutosComDesconto,
} from "../dominio/totaisDaConta";

const CustomerModal: React.FC<{
  isOpen: boolean;
  onRequestClose: (clearField: boolean) => void;
  setCustomerAddressToUpdate: (
    customerUuid: string,
    customerOrigin: string,
    customerName: string,
    customerPhone: string,
    // customerPlaceId: string,
    // customerFormattedAddress: string,
    customerAddress: string,
    customerAddressComplement: string,
    customerAddressObservation: string,
  ) => void;
  onCreateAddress: () => void;
  onUpdateAddress: () => void;
  searchValueInput: string;
  setSearchValueInput: (value: string) => void;
  setCustomerInfoByOrder: (value: any) => void;
  searchInputRefType3: any;
}> = ({
  isOpen,
  onRequestClose,
  setCustomerAddressToUpdate,
  onCreateAddress,
  onUpdateAddress,
  searchValueInput,
  setSearchValueInput,
  setCustomerInfoByOrder,
  searchInputRefType3,
}) => {
    const {
      authUserZustand,
      subsidiaryDataZustand,
      setSubsidiaryDataZustand,
      setOrderDataZustand,
      orderDataZustand,
      setMessageZustand,
    } = useCombinedStore();
    function formatTime(timeString: any) {
      const date = new Date(timeString);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${hours}:${minutes}:${seconds}`;
    }
    const [customerPhoneFilter, setCustomerPhoneFilter] =
      useState<string>(searchValueInput);
    const [CustomerNameFilter, setCustomerNameFilter] = useState<string>("");
    const modalWrapperRef = useRef<HTMLDivElement>(null);

    const [selectedRow, setSelectedRow] = useState<{
      customerUuid: string;
      customerOrigin: string;
      customerName: string;
      customerPhone: string;
      // customerPlaceId: string;
      // customerFormattedAddress: string;
      customerAddress: string;
      customerAddressComplement: string;
      customerAddressObservation: string;
    }>({
      customerUuid: "",
      customerOrigin: "",
      // customerPlaceId: "",
      // customerFormattedAddress: "",
      customerAddress: "",
      customerName: "",
      customerPhone: "",
      customerAddressComplement: "",
      customerAddressObservation: "",
    });
    const customersInfo = subsidiaryDataZustand.subsidiaryInfo.find(
      (info: any) => info.subsidiaryInfoType === 1
    );
    let customers = [];
    if (customersInfo) {
      try {
        const subsidiaryInfoValue = customersInfo.subsidiaryInfoValue;
        customers = typeof subsidiaryInfoValue === "string"
          ? JSON.parse(subsidiaryInfoValue)?.Customers
          : subsidiaryInfoValue?.Customers;
      } catch (error) {
        console.error("Error processing customersInfo.subsidiaryInfoValue:", error);
      }
    }
    const filteredRows = customers?.filter(
      (customer: any) =>
        customer.customerName
          .toLowerCase()
          .includes(CustomerNameFilter.toLowerCase()) &&
        customer.customerPhone
          .toString()
          .includes(customerPhoneFilter.toLowerCase())
    );
    const handleCloseModal = () => {
      setSelectedRow({
        customerUuid: "",
        customerOrigin: "",
        customerName: "",
        customerPhone: "",
        // customerPlaceId: "",
        // customerFormattedAddress: "",
        customerAddress: "",
        customerAddressComplement: "",
        customerAddressObservation: "",
      });

      onRequestClose(false);
    }

    useEffect(() => {
      if (isOpen) {
        setCustomerPhoneFilter(searchValueInput);
      }
    }, [isOpen, searchValueInput]);

    const handleSubmit = async () => {
      try {
        if (
          //selectedRow.customerPlaceId !== ""
          selectedRow.customerAddress !== "") {
          const getOrderByCustomerPhoneResponse = await api.get(
            `orderByCustomerPhone/${selectedRow.customerPhone.replace(
              "Fone: ",
              ""
            )}`
          );
          if (getOrderByCustomerPhoneResponse.data.currentOrderByPhone) {
            const infosDaConta =
              getOrderByCustomerPhoneResponse.data.currentOrderByPhone.order
                .orderInfo;
            const products = infosDoTipo(infosDaConta, 3);
            const productTotals = totalDosProdutosComDesconto(products);

            // Antes deste ponto o desconto era `acc + discountInfo.discountValue`
            // SEM converter, em três cópias: com "10%" gravado dava "010%" e o
            // total da tela saía "NaN"; com "3.00" dava "03.00". Agora é a
            // mesma função de desconto do resto do sistema. Card 25.
            // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos seis
            // caminhos do PDV e a mesma do cupom impresso. Card 25.
            const orderDiscount = descontoDaConta(
              infosDaConta,
              baseDoDesconto(products)
            );

            // `taxasDaConta` nunca devolve undefined — conta sem linha tipo 7
            // vira [] e as taxas saem 0,00 em vez de derrubar o modal.
            const orderTaxs = taxasDaConta(infosDaConta);
            const calculateTaxValue = (taxType: string) =>
              taxaPorTipo(orderTaxs, productTotals, taxType);

            const emReais = (valor: number) =>
              valor.toFixed(2).replace(".", ",");

            const totals = {
              totalProductsPrice: emReais(productTotals),
              totalDiscount: emReais(orderDiscount),
              totalProductsPriceWithDiscount: emReais(
                productTotals - orderDiscount
              ),
              serviceTax: emReais(calculateTaxValue("1")),
              entranceTax: emReais(calculateTaxValue("2")),
              minimumConsumption: emReais(calculateTaxValue("3")),
              parkTax: emReais(calculateTaxValue("4")),
              deliveryTax: emReais(calculateTaxValue("5")),
              customerBalance: "0",
              total: emReais(
                productTotals -
                orderDiscount +
                totalDeTaxas(orderTaxs, productTotals)
              ),
            };

            const orderPrinted: boolean =
              getOrderByCustomerPhoneResponse.data.currentOrderByPhone.orderInfo.some(
                (info: any) => info.orderInfoType === 14
              );

            const orderReturned =
              getOrderByCustomerPhoneResponse.data.currentOrderByPhone.order;
            //const formattedAddress = selectedRow.customerFormattedAddress;
            const address = selectedRow.customerAddress;
            setOrderDataZustand({
              ...orderDataZustand,
              orderUuid: orderReturned.orderUuid,
              orderCode: orderReturned.orderCode,
              orderOwnerUuid: orderReturned.updatedByUuid.userUuid,
              orderOwnerName: orderReturned.updatedByUuid.userSocialName,
              orderStatus: orderReturned.orderStatus,
              orderType: "3",
              createdAt: orderReturned.createdAt,
              orderInfo: {
                orderPrinted: orderPrinted,
                customerUuid: selectedRow.customerUuid,
                customerName: selectedRow.customerName,
                //customerAddress: selectedRow.customerFormattedAddress,
                customerAddress: selectedRow.customerAddress,
                customerAddressComplement: selectedRow?.customerAddressComplement,
                customerAddressObservation: selectedRow?.customerAddressObservation,
                orderTaxs: [...orderTaxs],
              },
              products:
                products.map((product: any) => {
                  const productInfo = JSON.parse(product.orderInfoValue);
                  const productObservations =
                    productInfo.productObservations?.map((observation: any) => {
                      return {
                        observationUuid: observation.observationUuid,
                        observationName: observation.observationName,
                        observationPrice: observation.observationPrice,
                      };
                    });
                  return {
                    productOrderUuid: product.orderInfoUuid,
                    productSelected: false,
                    productSemiSelected: false,
                    productUuid: productInfo.productUuid,
                    // `productCode` faltava neste mapeamento e só neste — o
                    // tipo `ProdutoDaConta` o exige e os outros três lugares
                    // que montam produto já o preenchiam. Antes chegava
                    // `undefined` na tela. Card 25.
                    productCode: productInfo.productCode,
                    productPrinted: productInfo.productPrinted,
                    productName: productInfo.productName,
                    productPrice: productInfo.productPrice,
                    peopleNumber: productInfo.peopleNumber,
                    seller: authUserZustand?.userInfo.userSocialName,
                    productDiscount: productInfo.productDiscount ?? "0",
                    productTotalPrice: productInfo.productPrice,
                    people: productInfo.peopleNumber,
                    productOrderedAt: formatTime(String(product.createdAt)),
                    productObservations: productObservations,
                  };
                }) ?? [],
              totals: totals,
            });

            searchInputRefType3.current.value = `Fone: ${selectedRow.customerPhone}`;
            setSearchValueInput(selectedRow.customerPhone);
            const CustomerOriginLabel =
              selectedRow.customerOrigin === "directContact"
                ? "Telefone"
                : selectedRow.customerOrigin === "externalApp"
                  ? "Aplicativo externo (Ifood, Rappi...)"
                  : selectedRow.customerOrigin === "internalApp"
                    ? "Aplicativo interno (Alfredo, Lucco)"
                    : "Outros";

            setCustomerInfoByOrder({
              customerName: selectedRow.customerName,
              // customerAddress: formattedAddress,
              customerAddress: selectedRow.customerAddress,
              customerAddressComplement: selectedRow.customerAddressComplement,
              customerAddressObservation: selectedRow.customerAddressObservation,
              customerOrigin: CustomerOriginLabel,
              customerPhone: `Fone: ${selectedRow.customerPhone}`,
            });
            handleCloseModal();
          } else {
            const openOrderResponse = await api.post(`order`, {
              orderOwnerUuid: authUserZustand?.userInfo.userUuid,
              period: subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid,
              orderType: "DELIVERY",
              orderInfo: {
                customerUuid: selectedRow.customerUuid,
                //customerPlaceId: selectedRow.customerPlaceId,
                customerAddress: selectedRow.customerAddress,

              },
            });
            if (openOrderResponse.status === 201) {
              //let formattedAddress = selectedRow.customerFormattedAddress;
              let address = selectedRow.customerAddress;
              setOrderDataZustand({
                ...orderDataZustand,
                orderUuid: openOrderResponse.data.order?.createdOrder?.orderUuid,
                orderCode: openOrderResponse.data.order?.createdOrder?.orderCode,
                orderOwnerUuid:
                  openOrderResponse.data.order?.createdOrder?.updatedByUuid
                    .userUuid,
                orderOwnerName:
                  openOrderResponse.data.order?.createdOrder?.updatedByUuid
                    .userSocialName,
                orderStatus: 0,
                orderType: "3",
                createdAt:
                  openOrderResponse.data.order?.createdOrder?.createdAt,
                orderInfo: {
                  customerUuid: selectedRow.customerUuid,
                  customerName: selectedRow.customerName,
                  //customerAddress: formattedAddress,
                  customerAddress: address,
                  customerAddressComplement:
                    selectedRow.customerAddressComplement,
                  orderTaxs: [openOrderResponse.data.order?.deliveryTax],
                },
                products: [],
                totals: {},
              });
              searchInputRefType3.current.value = `Fone: ${selectedRow.customerPhone}`;
              setSearchValueInput(`Fone: ${selectedRow.customerPhone}`);
              const CustomerOriginLabel =
                selectedRow.customerOrigin === "directContact"
                  ? "Telefone"
                  : selectedRow.customerOrigin === "externalApp"
                    ? "Aplicativo externo (Ifood, Rappi...)"
                    : selectedRow.customerOrigin === "internalApp"
                      ? "Aplicativo interno (Alfredo, Lucco)"
                      : "Outros";
              setCustomerInfoByOrder({
                customerName: selectedRow.customerName,
                //customerAddress: formattedAddress,
                customerAddress: address,
                customerAddressComplement: selectedRow.customerAddressComplement,
                customerAddressObservation: selectedRow.customerAddressObservation,
                customerOrigin: CustomerOriginLabel,
                customerPhone: `Fone: ${selectedRow.customerPhone}`,
              });
              handleCloseModal();
              setMessageZustand(
                `Pedido ${openOrderResponse.data.order?.createdOrder?.orderCode} aberto com sucesso!`,
                `success`
              );
            }
          }
        } else {
          setMessageZustand("Selecione um endereço para continuar.", "error");
        }
      } catch (error: any) {
        if (error.message === "Network Error") {
          setMessageZustand(
            `Erro ao tentar abrir nova conta, entre em contato com os administradores do Alfredo da sua unidade.`,
            `error`
          );
        } else {
          setMessageZustand(
            `Erro ao abrir uma nova conta: ${error.message}`,
            `error`
          );
        }
      }
    };

    const handleCheckboxChange = (
      customerUuid: string,
      customerOrigin: string,
      customerName: string,
      customerPhone: string,
      // customerPlaceId: string,
      // customerFormattedAddress: string,
      customerAddress: string,
      customerAddressComplement: string,
      customerAddressObservation: string
    ) => {
      setSelectedRow({
        customerUuid,
        customerOrigin,
        customerName,
        customerPhone,
        // customerPlaceId,
        // customerFormattedAddress,
        customerAddress,
        customerAddressComplement,
        customerAddressObservation,
      });
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (event.key === "Enter") {
        handleSubmit();
      }
    };

    const handleCreateAddress = () => {
      setSelectedRow({
        customerUuid: "",
        customerOrigin: "",
        customerName: "",
        customerPhone: "",
        // customerPlaceId: "",
        // customerFormattedAddress: "",
        customerAddress: "",
        customerAddressComplement: "",
        customerAddressObservation: "",
      });
      onCreateAddress();
    };
    const handleUpdateAddress = async () => {
      if (selectedRow.customerUuid === "") {
        setMessageZustand("Selecione um endereço para continuar.", "error");
      }
      else {
        setSelectedRow({
          customerUuid: "",
          customerOrigin: "",
          customerName: "",
          customerPhone: "",
          // customerPlaceId: "",
          // customerFormattedAddress: "",
          customerAddress: "",
          customerAddressComplement: "",
          customerAddressObservation: "",
        });
        setCustomerAddressToUpdate(
          selectedRow.customerUuid,
          selectedRow.customerOrigin,
          selectedRow.customerName,
          selectedRow.customerPhone,
          // selectedRow.customerPlaceId,
          // selectedRow.customerFormattedAddress,
          selectedRow.customerAddress,
          selectedRow.customerAddressComplement,
          selectedRow.customerAddressObservation
        );
        onUpdateAddress();
      }
    };
    const handleKeyDown = async (
      event: React.KeyboardEvent<HTMLInputElement>
    ) => {
      if (event.key === "Enter") {
        await handleSubmit();
      }
    }
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCloseModal}
        style={Styles.customStyles}
        contentLabel="Main Modal"
        ariaHideApp={false}
      >
        <MessageBox />
        <Styles.ModalWrapper
          tabIndex={-1}
          ref={modalWrapperRef}
          onKeyDown={handleKeyDown}
        >
          <Styles.CloseButton onClick={handleCloseModal}>
            &times;
          </Styles.CloseButton>
          <Styles.ModalContent>
            <Styles.ModalHeader
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
              <Styles.ModalTitle>Endereços de Clientes</Styles.ModalTitle>
              <Styles.ModalDescription>{`Pesquise ou cadastre um novo endereço de clientes.`}</Styles.ModalDescription>
            </Styles.ModalHeader>
            <Styles.ModalBody
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .backgroundColor
              }
            >
              <Styles.RowContainer>
                <Styles.FieldLabel>
                  Pesquise pelo Telefone do Cliente:
                </Styles.FieldLabel>
                <Styles.FieldContainer>
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      autoFocus={true}
                      value={customerPhoneFilter}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerPhoneFilter(e.target.value)
                      }
                      onKeyPress={handleKeyPress}
                    />
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.FieldLabel>
                  Pesquise pelo Nome do Cliente:
                </Styles.FieldLabel>
                <Styles.FieldContainer>
                  <Styles.TextInput
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setCustomerNameFilter(e.target.value)
                      }
                      onKeyPress={handleKeyPress}
                    />
                  </Styles.TextInput>
                </Styles.FieldContainer>
              </Styles.RowContainer>
              <Styles.RowContainer>
                <Styles.TableContainer>
                  <Styles.CustomerTable>
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Selecionar</th>
                        <th style={{ width: "30%" }}>Telefone do Cliente</th>
                        <th style={{ width: "30%" }}>Nome do Cliente</th>
                        <th style={{ width: "40%" }}>Endereço do Cliente</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRows?.flatMap((customer: any) =>
                        customer?.customerAddresses?.map((address: any) => {
                          // const rowKey = `${customer.customerUuid}-${address.customerPlaceId}`;
                          //const selectedRowKey = `${selectedRow.customerUuid}-${selectedRow.customerPlaceId}`;
                          // const formattedAddressCell =
                          //   address.customerFormattedAddress || "";
                          const rowKey = `${customer.customerUuid}-${address.customerAddress}`;
                          const selectedRowKey = `${selectedRow.customerUuid}-${selectedRow.customerAddress}`;
                          const formattedAddressCell = address.customerAddress || "";
                          return (
                            <tr
                              key={rowKey}
                              className={
                                rowKey === selectedRowKey ? "selected" : ""
                              }
                              onClick={() =>
                                handleCheckboxChange(
                                  customer.customerUuid,
                                  customer.customerOrigin,
                                  customer.customerName,
                                  customer.customerPhone,
                                  // address.customerPlaceId,
                                  // address.customerFormattedAddress,
                                  address.customerAddress,
                                  address.customerAddressComplement ?? "",
                                  address.customerAddressObservation ?? ""
                                )
                              }
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  checked={rowKey === selectedRowKey}
                                  onChange={() => { }}
                                />
                              </td>
                              <td>{customer.customerPhone}</td>
                              <td>{customer.customerName}</td>
                              <td>{formattedAddressCell}</td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Styles.CustomerTable>
                </Styles.TableContainer>
              </Styles.RowContainer>
            </Styles.ModalBody>
            <Styles.ModalFooter
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <Styles.Button onClick={handleUpdateAddress}>
                Atualizar
              </Styles.Button>
              <Styles.Button onClick={handleCreateAddress}>
                Cadastrar
              </Styles.Button>
              <div style={{ display: "flex" }}>
                <Styles.Button onClick={handleCloseModal}>
                  Cancelar
                </Styles.Button>
                <Styles.Button onClick={handleSubmit}>
                  Selecionar
                </Styles.Button>
              </div>
            </Styles.ModalFooter>
          </Styles.ModalContent>
        </Styles.ModalWrapper>
      </Modal>
    );
  };

export default CustomerModal;
